import {FC} from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ArcElement,
  Tooltip,
  Legend,
  RadialLinearScale,
} from 'chart.js'
import {Bar, PolarArea} from 'react-chartjs-2'
import {DataErItem} from '../core/_models'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, RadialLinearScale)

type Props = {
  items: DataErItem[]
}

const ErChart: FC<Props> = ({items}) => {
  const labels = items.map((i) => i.extension)

  const dataBar = {
    labels,
    datasets: [
      {
        label: 'Вх.',
        data: items.map((i) => i.inbound),
        backgroundColor: 'rgba(54, 162, 235, 0.7)',
        borderWidth: 1,
        borderRadius: 5,
      },
      {
        label: 'Исх.',
        data: items.map((i) => i.outbound),
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
        borderWidth: 1,
        borderRadius: 5,
      },
    ],
  }

  const totalInbound = items.reduce((sum, i) => sum + i.inbound, 0)
  const totalOutbound = items.reduce((sum, i) => sum + i.outbound, 0)

  const dataPolarArea = {
    labels: ['Вх.', 'Исх.'],
    datasets: [
      {
        label: 'Звонки',
        data: [totalInbound, totalOutbound],
        backgroundColor: ['rgba(54, 162, 235, 0.7)', 'rgba(75, 192, 192, 0.7)'],
        borderWidth: 1,
        borderRadius: 5,
      },
    ],
  }

  return (
    <div className='row'>
      <div className='col-8'>
        <Bar
          data={dataBar}
          options={{
            responsive: true,
            plugins: {
              legend: {position: 'top'},
            },
          }}
        />
      </div>
      <div className='col-4'>
        <PolarArea
          data={dataPolarArea}
          options={{
            responsive: true,
            plugins: {
              legend: {position: 'top'},
            },
          }}
        />
      </div>
    </div>
  )
}

export {ErChart}
